import React, { Fragment } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { scale } from "utils"
import PloptfcustomerHeader from "./PloptfcustomerHeader"
import PloptfcustomerOrderDetails from "./PloptfcustomerOrderDetails"
import PloptfcustomerQrCode from "./PloptfcustomerQrCode"
import PloptfcustomerCustomerDetails from "./PloptfcustomerCustomerDetails"
import PloptfcustomerBarcode from "./PloptfcustomerBarcode"
import PloptfcCustomText from "./PloptfcCustomText"
import PloptfcBranchDetails from "./PloptfcBranchDetails"
import PlSeparator from "../PlSeparator"
import { languageSuffixMap } from "constant"
import PloptfcPagerQrCode from "./PloptfcPagerQrCode"

const CustomerPrintTemplate = (props) => {
  const {
    forPos,
    templateType,
    printData,
    printerWidth
  } = props

  const [t, i18n] = useTranslation()

  const customerPrintTemplate =
    useSelector(state => state.customerPrintTemplate)

  const validBarcode = (code) => !isNaN(code) && !!code

  const styles =
    templateType === "thermal" ? stylesThermal(printerWidth) : stylesOthers

  return (
    <Fragment>
      <div style={styles["title"]}>
        ({t("فاکتور خریدار")})
      </div>
      {customerPrintTemplate.map((component, index) =>
        <Fragment key={index}>
          {
            component.type === "header" &&
            <PloptfcustomerHeader
              templateType={templateType}
              printData={printData}
              printerWidth={printerWidth}
            />
          }
          {
            component.type === "customerDetails" &&
            <PloptfcustomerCustomerDetails
              templateType={templateType}
              printData={printData}
              printerWidth={printerWidth}
            />
          }
          {
            component.type === "orderDetails" &&
            <PloptfcustomerOrderDetails
              templateType={templateType}
              printData={printData}
              printerWidth={printerWidth}
            />
          }

          {
            component.type === "qrCode" &&
            <PloptfcustomerQrCode
              templateType={templateType}
              printData={printData}
              printerWidth={printerWidth}
            />
          }

          {
            validBarcode(printData.code) &&
            component.type === "barcode" &&
            <PloptfcustomerBarcode
              templateType={templateType}
              printData={printData}
              printerWidth={printerWidth}
            />
          }

          {
            component.type === "branchDetails" &&
            <PloptfcBranchDetails
              templateType={templateType}
              printData={printData}
              printerWidth={printerWidth}
            />
          }

          {
            component.type === "pagerQrCode" &&
            <PloptfcPagerQrCode
              templateType={templateType}
              printData={printData}
            />
          }

          {
            component.type === "customText" &&
            <PloptfcCustomText
              templateType={templateType}
              text={component[`text${languageSuffixMap[i18n.language]}`] || ""}
              printerWidth={printerWidth}
            />
          }
        </Fragment>
      )}

      <PlSeparator
        forPos={forPos}
        templateType={templateType}
      />
    </Fragment>
  )
}

const stylesThermal = (printerWidth) => ({
  title: {
    fontSize: scale("19px", printerWidth),
    textAlign: "center",
    marginBottom: scale("8px")
  }
})

const stylesOthers = {
  title: {
    fontSize: "13px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "5px"
  }
}

export default CustomerPrintTemplate